export default __webpack_public_path__ + "static/SRF 4400ACS10 - Fiche de spécifications et données techniques-b32c384fb59549d0c5957773da4dcf85.pdf";